import Bouncer from 'formbouncerjs';

export default new class Validation {
  constructor() {
    this.formForValidationSelector = '._required';
    this.inValidSelector = '_invalid';

    this.handler();
  }

  handler() {
    document.addEventListener('DOMContentLoaded', () => {
      this.validate(this.formForValidationSelector);
    });
  }

  validate(selector) {
    this.validation = new Bouncer(selector, {
      fieldClass: 'validation-error',
      errorClass: 'validation-error__message',
      fieldPrefix: 'validation-error-',
      errorPrefix: 'validation-error-',
      messageAfterField: true,
      messageCustom: 'data-bouncer-message',
      messageTarget: 'data-bouncer-target',
      disableSubmit: true,
      messages: {
        missingValue: {
          checkbox: 'Поле обязательно для заполнения.',
          radio: 'Выберите одно из значений.',
          select: 'Выберите из списка.',
          'select-multiple': 'Выберите одно из значений.',
          default: 'Заполните поле.',
        },
        patternMismatch: {
          email: 'Введите правильный Email адрес.',
          url: 'Введите URL.',
          number: 'Введите номер',
          color: 'Please match the following format: #rrggbb',
          date: 'Пожалуйста введите дату в формате Г-д-м',
          time: 'Please use the 24-hour time format. Ex. 23:00',
          month: 'Please use the YYYY-MM format',
          default: 'Please match the requested format.',
        },
        outOfRange: {
          over: 'Выберите значение, которое не превышает {max}.',
          under: 'Выберите значение не менее {min}.',
        },
        wrongLength: {
          over: 'Сократите этот текст до {maxLength} символов. В настоящее время вы используете {length} символов.',
          under: 'Удлините этот текст до {minLength} символов или больше. В настоящее время вы используете {length} символов.',
        },
      },
    });

    document.addEventListener('bouncerFormValid', ({ target }) => {
      target.classList.remove(this.inValidSelector);
    });

    document.addEventListener('bouncerFormInvalid', ({ target }) => {
      target.classList.add(this.inValidSelector);
    });
  }
}();
